import styled from "styled-components";
import { truncateText } from "@similarweb/styles";
import { DropdownButton, SimpleDropdownItem } from "@similarweb/ui-components";

export const StyledDropdownButton = styled(DropdownButton)`
    display: block;
    ${truncateText()};
`;

export const StyledDropdownItem = styled(SimpleDropdownItem)`
    ${truncateText()};
    max-width: calc(100% - 16px);
`;
